
(async function () {
    const reportFilters = document.getElementsByClassName("reportFilter")
    const baseTitle = document.title
    const baseUrl = location.href.split("?")[0]
    let page = 1
    const urlParams = new Proxy(new URLSearchParams(window.location.search), {
        get: (searchParams, prop) => searchParams.get(prop),
    });

    async function addChangeEvents(reportFilterElement) {
        const filterTopicSelect = reportFilterElement.querySelector(".filter.topic select")
        const filterTypeSelect = reportFilterElement.querySelector(".filter.type select")
        const filterYearSelect = reportFilterElement.querySelector(".filter.year select")
        const filterSortSelect = reportFilterElement.querySelector(".filter.sort select")
        const filterSearchInput = reportFilterElement.querySelector(".filter.search input")

        filterTopicSelect.addEventListener("change", () => { page = 1;  populateResults(reportFilterElement) })
        filterTypeSelect.addEventListener("change", () => { page = 1; populateResults(reportFilterElement) })
        filterYearSelect.addEventListener("change", () => { page = 1;  populateResults(reportFilterElement) })
        filterSortSelect.addEventListener("change", () => { page = 1;  populateResults(reportFilterElement) })
        filterSearchInput.addEventListener("input", () => { page = 1;  populateResults(reportFilterElement) })
    }

    function setSelectedFromUrl(reportFilterElement) {
        const filterPage = parseInt(urlParams.page)
        if (filterPage != null && Number.isInteger(filterPage) && filterPage > 0) {
            page = filterPage
        }
        const filterSearchValue = urlParams.search;
        if (filterSearchValue != null) { reportFilterElement.querySelector(".filter.search input").value = filterSearchValue }
        const filterTopicValue = urlParams.topic;
        if (filterTopicValue != null) { reportFilterElement.querySelector(".filter.topic select").value = filterTopicValue }
        const filterTypeValue = urlParams.type;
        if (filterTypeValue != null) { reportFilterElement.querySelector(".filter.type select").value = filterTypeValue }
        const filterYearValue = urlParams.year;
        if (filterYearValue != null) { reportFilterElement.querySelector(".filter.year select").value = filterYearValue }
        const filterSortValue = urlParams.sort;
        if (filterSortValue) {
            reportFilterElement.querySelector(".filter.sort select").value = filterSortValue;
        }
    }

    function getUrlQueryString(reportFilterElement, pageValue) {
        const filterPageValue = pageValue;
        const filterSearchValue = reportFilterElement.querySelector(".filter.search input").value.trim()
        const filterTopicValue = reportFilterElement.querySelector(".filter.topic select").value
        const filterTypeValue = reportFilterElement.querySelector(".filter.type select").value
        const filterYearValue = reportFilterElement.querySelector(".filter.year select").value
        const filterSortValue = reportFilterElement.querySelector(".filter.sort select").value
        return `?page=${filterPageValue}&search=${encodeURIComponent(filterSearchValue)}&topic=${encodeURIComponent(filterTopicValue)}&type=${encodeURIComponent(filterTypeValue)}&year=${encodeURIComponent(filterYearValue)}&sort=${encodeURIComponent(filterSortValue)}&arp=${reportFilterElement.dataset.arp}`;
    }

    function setUrl(reportFilterElement, id) {
        let url = `${baseUrl}${getUrlQueryString(reportFilterElement, page)}`
        if (id) {
            url += `&id=${encodeURIComponent(id)}`;
        } else {
            document.title = `${baseTitle}`
        }
        history.pushState(null, baseTitle, url);
    }

    async function populateResults(reportFilterElement, doNotSetUrl) {
        if (!doNotSetUrl) {
            setUrl(reportFilterElement)
        }
        // Clear existing results
        for (let item of reportFilterElement.querySelector(".list")
            .querySelectorAll(".result:not(.template)")) {
            item.remove()
        }

        //reportFilterElement.querySelector(".results").classList.add("hidden")

        const take = parseInt(reportFilterElement.dataset.take) || 10
        let skip = (page - 1) * take; //  parseInt(reportFilterElement.dataset.skip) || 0
        //if (!addData) {
        //    // Clear existing results
        //    for (let item of reportFilterElement.querySelector(".list")
        //        .querySelectorAll(".result:not(.template)")) {
        //        item.remove()
        //    }
        //    skip = 0
        //}
        reportFilterElement.querySelector(".titlefound").classList.add("hidden")
        reportFilterElement.querySelector(".titlenotfound").classList.add("hidden")


        // Get filter values
        const filterSearchValue = reportFilterElement.querySelector(".filter.search input").value.trim()
        const filterTopicValue = reportFilterElement.querySelector(".filter.topic select").value
        const filterTypeValue = reportFilterElement.querySelector(".filter.type select").value
        const filterYearValue = reportFilterElement.querySelector(".filter.year select").value
        const filterSortValue = reportFilterElement.querySelector(".filter.sort select").value
        //reportFilterElement.dataset.skip = skip + take

        let sortValue = 0;
        if (filterSortValue == "Oldest") {
            sortValue = 1;
        }
        if (filterSortValue == "AToZ") {
            sortValue = 2;
        }
        if (filterSortValue == "ZToA") {
            sortValue = 3;
        }

        const postData = {
            criteria: {
                Search: filterSearchValue,
                Topic: filterTopicValue,
                Type: filterTypeValue,
                Year: filterYearValue ? parseInt(filterYearValue) : null,
                Sort: sortValue,
                Skip: skip,
                Take: take,

            }
        }

        //console.log("Populating results for filter:", postData);
        // Fetch data from the API
        await fetch(`/umbraco/api/reports/getreportsusingdeliveryapi/`, {
            method: "POST",
            cache: "no-store",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(postData)
        })
            .then(response => response.json())
            .then(async (data) => {
                console.log(data)
                await populateListData(reportFilterElement, data)
                populatePagination(reportFilterElement, data, skip, take)
                populateNumItems(reportFilterElement, data, skip, take)

                reportFilterElement.scrollIntoView()
            })
    }


    function populateNumItems(reportFilterElement, data, skip, take) {
        const firstItem = (skip / take) * take + 1
        const lastItem = firstItem + take - 1 > data.total ? data.total : firstItem + take - 1
        const numShowing = lastItem - firstItem + 1

        reportFilterElement.querySelector(".numfirst").innerHTML = firstItem
        reportFilterElement.querySelector(".numtotal").innerHTML = data.total
        reportFilterElement.querySelector(".numshowing").innerHTML = lastItem

        if (numShowing > 0) {
            reportFilterElement.querySelector(".titlefound").classList.remove("hidden")
        } else {
            reportFilterElement.querySelector(".titlenotfound").classList.remove("hidden")
        }

    }

    async function populateListData(reportFilterElement, data) {
        const list = reportFilterElement.querySelector(".list")
        const resultElement = reportFilterElement.querySelector(".result")
        if (data.items) {
            for (let item of data.items) {
                const itemElement = resultElement.cloneNode(true)
                itemElement.querySelector(".content").href = `${item.url}${getUrlQueryString(reportFilterElement, page)}`
                itemElement.classList.remove("template")
                itemElement.dataset.id = item.id
                const repTypeSingular = item.repTypeSingular
                if (!repTypeSingular) {
                    repTypeSingular = item.repType
                }
                itemElement.querySelector(".reportType").textContent = repTypeSingular
                itemElement.querySelector(".heading").textContent = item.name
                const teaserEl = itemElement.querySelector(".teaser")
                populateTeaser(teaserEl, item.teaserImage)
                itemElement.querySelector(".date").textContent = `${reportFilterElement.dataset.published} ${item.reportDate}`
                itemElement.querySelector(".summary").textContent = item.summary
                if (item.documents && item.documents.length > 0) {
                    const docsEl = itemElement.querySelector(".docs")
                    const downloadText = docsEl.dataset.download
                    item.documents.forEach(doc => {
                        docsEl.appendChild(documentEl(doc, downloadText))
                    });
                }
                const topicEls = itemElement.querySelectorAll(".topic")
                for (let i = 0; i < topicEls.length; i++) {
                    topicEls[i].textContent = item.repTopic
                    topicEls[i].addEventListener("click", (e) => {
                        e.preventDefault()

                        resetSelections(reportFilterElement)
                        reportFilterElement.querySelector(".filter.topic select").value = item.repTopic
                        populateResults(reportFilterElement)
                    })
                }
                const typeEls = itemElement.querySelectorAll(".type")
                for (let i = 0; i < typeEls.length; i++) {
                    typeEls[i].textContent = item.repType
                    typeEls[i].addEventListener("click", (e) => {
                        e.preventDefault()
                        resetSelections(reportFilterElement)
                        reportFilterElement.querySelector(".filter.type select").value = item.repType
                        populateResults(reportFilterElement)
                    })
                }
                list.appendChild(itemElement)
            }
        }
        list.classList.remove("hidden")
        //reportFilterElement.querySelector(".results").classList.remove("hidden")
    }


    function populateTeaser(teaserEl, teaserImage) {
        teaserEl.classList.add("hidden")
        for (let item of teaserEl.querySelectorAll("*")) {
            item.remove()
        }
        if (teaserImage) {
            const teaserimageEl = document.createElement("img")
            teaserimageEl.setAttribute("src", teaserImage.url)
            teaserimageEl.setAttribute("alt", teaserImage.name)
            teaserEl.appendChild(teaserimageEl)
            teaserEl.classList.remove("hidden")
        }
    }

    function resetSelections(reportFilterElement) {
        page = 1
        reportFilterElement.querySelector(".filter.topic select").value = ""
        reportFilterElement.querySelector(".filter.type select").value = ""
        reportFilterElement.querySelector(".filter.year select").value = ""
        reportFilterElement.querySelector(".filter.sort select").value = "Newest"
        reportFilterElement.querySelector(".filter.search input").value = ""
        reportFilterElement.dataset.skip = 0
    }

    function documentEl(doc, downloadText) {
        const docLink = document.createElement("a")
        docLink.href = doc.url
        docLink.classList.add("doc-link")
        docLink.classList.add("bl")
        docLink.setAttribute("title", doc.name)
        docLink.setAttribute("style", "background-color:#05acc1;color:#FFFFFF;")
        docLink.textContent = `${downloadText} ${doc.documentType}, ${doc.size}`
        docLink.target = "_blank" // Open in new tab

        const docEl = document.createElement("div")
        docEl.classList.add("buttonlink")
        docEl.appendChild(docLink)

        return docEl
    }

    function populatePagination(reportFilterElement, data, skip, take) {
        const paginationElement = reportFilterElement.querySelector(".pagination-container")
        paginationElement.innerHTML = ''
        const pagination = document.createElement("ul")
        pagination.classList.add("pagination")
        const total = data.total
        const numPages = Math.ceil(total.toFixed(2) / take.toFixed(2))
        const currentPage = Math.floor(skip / take) + 1;
        if (numPages > 0) {
            for (let i = 0; i < numPages; i++) {
                const p = i + 1
                const pageElement = document.createElement("li")
                if (p == currentPage) {
                    pageElement.classList.add("active")
                    pageElement.innerHTML = `<span>${p}</span>`
                } else {
                    const pageLink = document.createElement("a")
                    pageLink.innerText = p
                    pageLink.href = `${getUrlQueryString(reportFilterElement, p)}`
                    pageLink.addEventListener("click", e => {
                        e.preventDefault()
                        page = parseInt(e.target.innerText)
                        populateResults(reportFilterElement)
                    })
                    pageElement.appendChild(pageLink)
                }
                pagination.appendChild(pageElement)
            }
        }
        paginationElement.appendChild(pagination)
        paginationElement.classList.remove("hidden")
        const alert = reportFilterElement.querySelector(".alert")
        alert.classList.add("hidden")
        if (skip > data.total) {
            alert.classList.remove("hidden")
            paginationElement.classList.add("hidden")
            const url = document.location.href.split("?")[0]
            document.location.href = url; // Redirect to base url
        }

    }

    async function populateFilterSelections(reportFilterElement, callback) {
        const filterId = reportFilterElement.getAttribute("data-id");
        if (!filterId) {
            console.error("Report filter element is missing data-id attribute.");
            return;
        }
        const filterTopicSelect = reportFilterElement.querySelector(".filter.topic select")
        const filterTypeSelect = reportFilterElement.querySelector(".filter.type select")
        const filterYearSelect = reportFilterElement.querySelector(".filter.year select")
        const defaultType = reportFilterElement.getAttribute("data-defaulttype");
        const defaultTypeOnly = reportFilterElement.getAttribute("data-defaulttypeonly") == "True"

        fetch(`/umbraco/api/reports/getreporttypeset/${filterId}?defaultTypeId=${defaultType}`, { cache: "no-store" })
            .then(response => response.json())
            .then(data => {
                //console.log("Received filter data:", data);
                if (data.defaultTeaser) {
                    reportFilterElement.dataset.teasername = data.defaultTeaser.name
                    reportFilterElement.dataset.teaserurl = data.defaultTeaser.url
                }
                if (data.types && data.types.length > 0) {
                    let selectedIndex = 0;
                    let index = 1;
                    data.types.forEach(type => {
                        if (type.default) {
                            selectedIndex = index;
                        }
                        if (defaultTypeOnly && !type.default) {
                            return; // Skip topics if only the default is needed
                        }
                        const option = document.createElement("option")
                        option.value = type.name
                        option.textContent = type.name
                        if (type.defaultTeaser) {
                            option.dataset.teasername = type.defaultTeaser.name
                            option.dataset.teaserurl = type.defaultTeaser.url;
                        }
                        filterTypeSelect.appendChild(option);
                        index++;
                    });
                    filterTypeSelect.selectedIndex = selectedIndex;
                    if (defaultTypeOnly) {
                        // remove the "all" option
                        filterTypeSelect.options[0].remove();
                    }

                } else {
                    console.warn("No topics found for filterId:", filterId);
                }
                if (data.topics && data.topics.length > 0) {
                    data.topics.forEach(topic => {
                        const option = document.createElement("option");
                        option.value = topic;
                        option.textContent = topic;
                        if (topic.defaultTeaser) {
                            option.dataset.teasername = topic.defaultTeaser.name
                            option.dataset.teaserurl = topic.defaultTeaser.url;
                        }
                        filterTopicSelect.appendChild(option);
                    });
                } else {
                    console.warn("No types found for filterId:", filterId);
                }
                if (data.years && data.years.length > 0) {
                    data.years.forEach(year => {
                        const option = document.createElement("option");
                        option.value = year;
                        option.textContent = year;
                        filterYearSelect.appendChild(option);
                    });
                } else {
                    console.warn("No years found for filterId:", filterId);
                }
                if (callback) {
                    callback()
                }
            })
    }

    if (reportFilters != null) {
        for (let reportFilterElement of reportFilters) {
            await populateFilterSelections(reportFilterElement, async () => {
                setSelectedFromUrl(reportFilterElement)
                await addChangeEvents(reportFilterElement)
                await populateResults(reportFilterElement, false, true)

            })
        }
    }

})();